import React, { Component } from 'react'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";
import { defineMessages, injectIntl } from 'react-intl'
import GlobalHelper from '../common/GlobalHelper';
import { getPriceListName } from '../name-helpers/priceListNameHelper';

const messages = defineMessages({
    "select_payment_method_label": {
        id: 'invoice.receive_payment.select_payment_method_label',
        defaultMessage: 'Select payment method',
    },
    "credit_card_label": {
        id: 'invoice.receive_payment.type_credit_card_label',
        defaultMessage: 'Credit card',
    },
    "check_label": {
        id: 'invoice.receive_payment.check_label',
        defaultMessage: 'Check',
    },
    "cash_label": {
        id: 'invoice.receive_payment.cash_label',
        defaultMessage: 'Cash',
    },
    "bank_transfer_label": {
        id: 'invoice.receive_payment.bank_transfer_label',
        defaultMessage: 'Bank transfer',
    },
    "credit_label": {
        id: 'invoice.receive_payment.credit_label',
        defaultMessage: 'Credit ({amount} left)',
    },
    "quote_deposit_without_amount_label": {
        id: 'invoice.receive_payment.type_quote_deposit_no_amount_label',
        defaultMessage: 'Deposits from quotes',
    },
    "order_deposit_without_amount_label": {
        id: 'invoice.receive_payment.type_order_deposit_no_amount_label',
        defaultMessage: 'Deposits from orders',
    },
    "price_list_deposit_without_amount_label": {
        id: 'invoice.receive_payment.type_price_list_deposit_no_amount',
        defaultMessage: 'Deposits from linked order {priceList}',
    },
})

class PaymentTypeSelect extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            isFilter: props.isFilter || false,
            paymentType: this.props.paymentType || '',
            customPaymentTypes: [],
            customPaymentTypeId: '',
            onChange: this.props.onChange || function () { },
            creditBalance: this.props.creditBalance || 0,
            depositBalance: this.props.depositBalance || 0,
            creditCurrency: this.props.creditCurrency || '',
            disabled: this.props.disabled || false,
            hideDepositTotalAmountLeft: this.props.hideDepositTotalAmountLeft || false,
            orderReferenceId: this.props.orderReferenceId || '',
            priceListReferenceId: '',
        }
        this.onChange = this.onChange.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
    }

    componentDidMount() {
        AppContext.getApiClient().get('/payment-types').then(res => {
            const enabledPaymentTypes = res.data.filter(paymentType => paymentType.attributes.status === "enabled")
            this.setState({
                customPaymentTypes: enabledPaymentTypes,
            })
        })

        if (this.state.orderReferenceId) {
            AppContext.getApiClient().get(`/orders/${this.state.orderReferenceId}`).then(res => {
                if (!res.error && res.attributes) {
                    this.setState({
                        priceListReferenceId: res.attributes.priceListReferenceId,
                    })
                }
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            creditBalance: nextProps.creditBalance || 0,
            depositBalance: nextProps.depositBalance || 0,
            creditCurrency: nextProps.creditCurrency || '',
            disabled: nextProps.disabled || false,
            paymentType: nextProps.paymentType || this.state.paymentType,
            orderReferenceId: nextProps.orderReferenceId || '',
        })
    }

    handleFormChange(event) {
        const target = event.target;
        let value = target.value
        if (target.name === "paymentType") {
            const customPaymentType = this.state.customPaymentTypes.find(cPaymentType => cPaymentType.id === value)
            if (customPaymentType) {
                this.setState({
                    customPaymentTypeId: value,
                })
            } else {
                this.setState({
                    customPaymentTypeId: '',
                })
            }
        }

        this.setState({
            [target.name]: target.value
        }, this.onChange)
    }

    onChange() {
        let paymentType = this.state.paymentType
        let paymentLabel = this.state.paymentType
        if (this.state.customPaymentTypeId) {
            const customPaymentType = this.state.customPaymentTypes.find(cPaymentType => cPaymentType.id === this.state.customPaymentTypeId)
            if (customPaymentType) {
                paymentType = customPaymentType.attributes.name
                paymentLabel = customPaymentType.attributes.name
            }
        }
        if (this.state.isFilter) {

            if (paymentType === 'credit-card') {
                paymentLabel = this.props.intl.formatMessage(messages["credit_card_label"])
            } else if (paymentType === 'check') {
                paymentLabel = this.props.intl.formatMessage(messages["check_label"])
            } else if (paymentType === 'bank-transfer') {
                paymentLabel = this.props.intl.formatMessage(messages["bank_transfer_label"])
            } else if (paymentType === 'cash') {
                paymentLabel = this.props.intl.formatMessage(messages["cash_label"])
            } else if (paymentType === 'deposit') {
                paymentLabel = this.props.intl.formatMessage(messages["deposit_without_amount_label"])
            } else {
                if (this.state.customPaymentTypeId) {
                    paymentType = this.state.customPaymentTypeId
                }
            }

            this.props.onChange(paymentType, paymentLabel)
        } else {
            this.state.onChange(paymentType, this.state.customPaymentTypeId)
        }
    }

    render() {
        return <select
            name="paymentType"
            value={this.state.paymentType}
            onChange={this.handleFormChange}
            id="paymentType"
            className="form-control"
            disabled={this.state.disabled}
        >
            <option disabled value=''> {this.props.intl.formatMessage(messages["select_payment_method_label"])} </option>
            <option value={'credit-card'}>
                {this.props.intl.formatMessage(messages["credit_card_label"])}
            </option>
            <option value={'check'}>
                {this.props.intl.formatMessage(messages["check_label"])}
            </option>
            <option value={'bank-transfer'}>
                {this.props.intl.formatMessage(messages["bank_transfer_label"])}
            </option>
            <option value={'cash'}>
                {this.props.intl.formatMessage(messages["cash_label"])}
            </option>
            {this.state.creditBalance > 0 ? <option value={'credit'}>
                {this.props.intl.formatMessage(messages["credit_label"], {
                    amount: this.props.intl.formatNumber(this.state.creditBalance, {
                        style: 'currency',
                        currency: this.state.creditCurrency,
                    })
                })}
            </option> : null}

            {
                !GlobalHelper.hasShopifyIntegrationWithDisabledFeatures() &&
                <>
                    {((this.state.depositBalance > 0) ? <option value={'quote-deposit'}>
                        {this.props.intl.formatMessage(messages["quote_deposit_without_amount_label"])}
                    </option> : null)}

                    {(this.state.depositBalance > 0) ? <option value={'order-deposit'}>
                        {this.props.intl.formatMessage(messages["order_deposit_without_amount_label"])}
                    </option> : null}

                    {(this.state.orderReferenceId && this.state.priceListReferenceId) ? <option value={'price-list-deposit'}>
                        {this.props.intl.formatMessage(messages["price_list_deposit_without_amount_label"], {
                            priceList: getPriceListName(this.props.intl)
                        })}
                    </option> : null}


                    {this.state.customPaymentTypes.map(customPaymentType => {
                        return <option key={customPaymentType.id} value={customPaymentType.id}>
                            {customPaymentType.attributes.name}
                        </option>
                    })}
                </>
            }
        </select>
    }
}

export default injectIntl(PaymentTypeSelect)


// WEBPACK FOOTER //
// ./src/payment-type/paymenttypeselect.jsx